module.exports = __webpack_public_path__ + "media/images/cleveland-clinic-78f9c618cda284a6ee17f86b620fe1b5.png";